import React, { Fragment } from 'react';
import styled from 'styled-components/macro';

import AnimatedPath from 'components/data-visualization/AnimatedPath/AnimatedPath';

const AnimatedGradientPath = styled(AnimatedPath)`
  fill: transparent;
  stroke-linejoin: round;
`;

interface IGradient {
  data: {
    periodKey: number | Date;
    position: number;
  }[];
  gradient: (data: any) => any;
  color: string;
  keyValue: string;
}

const Gradient: React.FC<IGradient> = (props) => {
  const { data, gradient, color, keyValue } = props;

  return (
    <Fragment key={`gradient-${keyValue}`}>
      <defs>
        <linearGradient
          id={`gradient-fill-${keyValue}`}
          x1={0}
          x2={0}
          y1={0}
          y2={1}
        >
          <stop offset="0%" stopColor={color} stopOpacity="0.15" />
          <stop offset="75%" stopColor="white" stopOpacity="0" />
        </linearGradient>
      </defs>
      <AnimatedGradientPath
        pathString={gradient(data)}
        style={{ fill: `url(#gradient-fill-${keyValue})` }}
      />
    </Fragment>
  );
};

export default Gradient;
